import React, { useState, useEffect } from "react";
import axios from "axios";
import { useAuth } from "../context/AuthContext";
import { loadStripe } from "@stripe/stripe-js";
import { Elements, CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
import "./PaymentForm.css"
import BusinessLogin  from "./BusinessLogin"
import Navbar from "./Navbar";

// Definice vzhledu pro Stripe
const appearance = {
  theme: 'stripe',  // Téma Stripe formuláře
  variables: {
    colorPrimary: '#0570de',  // Primární barva
    colorBackground: '#ffffff',  // Barva pozadí
    colorText: '#30313d',  // Barva textu
    colorDanger: '#df1b41',  // Barva pro chyby
    fontFamily: 'Ideal Sans, system-ui, sans-serif',  // Font
    spacingUnit: '2px',  // Základní mezery
    borderRadius: '4px',  // Zakulacení rohů
  },
};

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);  // Ujistěte se, že používáte správný veřejný klíč

const PaymentForm = () => {
  const [plan, setPlan] = useState("");  // Ukládá vybraný plán
  const [message, setMessage] = useState("");  // Zpráva pro uživatele
  const { businessToken, business } = useAuth();  // Používáme token a údaje o firmě z kontextu
  const stripe = useStripe();  // Stripe API
  const elements = useElements();  // Elements pro práci s kartou
  const [paymentData, setPaymentData] = useState([])
  const [loading, setLoading] = useState(false)

  const getNewPaymentData = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/payments/infosubscribe`,
        {
          params: {
            businessId: business._id,
            paymentId: business.lastPayment,
          },
          headers: { Authorization: `Bearer ${businessToken}` },
        }
      );
      setPaymentData(response.data.data);
    } catch (error) {
      console.log("Nejsou data");
    }
  };

  useEffect(() => {
    if (businessToken && business) {
      // Získání platebních dat pro daný účet firmy
      const getPaymentData = async () => {
        try {
          const response = await axios.get(
            `${process.env.REACT_APP_API_URL}/payments/infosubscribe`,
            {
              params: {
                businessId: business._id,
                paymentId: business.lastPayment,
              },
              headers: { Authorization: `Bearer ${businessToken}` },
            }
          );
          setPaymentData(response.data.data);
        } catch (error) {
          console.log("Nejsou data");
        }
      };

      getPaymentData();
    }
  }, [business, businessToken]);

    useEffect(() => {
      const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
      scrollToTop()
    }, [])

  const handleSubmit = async (event) => {
    event.preventDefault();
    
    if (!stripe || !elements) {
      return;
    }

    try {
      setLoading(true)
      // Vytvoření platební metody pomocí Stripe
      const { error, paymentMethod } = await stripe.createPaymentMethod({
        type: "card",
        card: elements.getElement(CardElement),
      });

      if (error) {
        setMessage(error.message);  // Pokud je chyba při vytvoření platební metody
        return;
      }
      console.log("PaymentMethod ID:", paymentMethod.id);
      console.log("Odesílám na backend:", {
        businessId: business?._id,
        plan,
        paymentMethodId: paymentMethod.id,
      });
      const { data } = await axios.post(`${process.env.REACT_APP_API_URL}/payments/subscribe`, {
        businessId: business._id,
        plan: plan,  // Přidáme plán (měsíčně/ročně)
        paymentMethodId: paymentMethod.id,  // Odesíláme ID platební metody
      }, {
        headers: { Authorization: `Bearer ${businessToken}` },
      });
      
      const clientSecret = data.clientSecret;

      if (!clientSecret) {
        setMessage(data.message);
        return;
      }
      
      // Potvrzení platby pomocí Stripe
      const confirmPayment = await stripe.confirmCardPayment(clientSecret, {
        payment_method: paymentMethod.id,
      });

      if (confirmPayment.error) {
        setMessage(confirmPayment.error.message);  // Pokud je chyba při platbě
      } else {
        setMessage("Platba byla úspěšně zpracována!");  // Úspěšná platba
      }

    } catch (error) {
      setMessage(error.response?.data?.message || "Došlo k chybě při zpracování platby.");
      console.error("Chyba při zpracování platby:", error);
    } finally {
      setLoading(false)
      setTimeout(() => {
        setMessage(null)
        window.location.reload()
        getNewPaymentData()
      }, 1500)
  
    }
  };

  // Zrušení předplatného
  const handleCancel = async () => {
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/payments/cancel`, 
        {
          businessId: business._id,
        },
        {
          headers: {
            Authorization: `Bearer ${businessToken}`
          },
        },
      );

      setMessage(response.data.message);
    } catch (err) {
      console.log(err.response?.data?.message);
    } finally {
      setTimeout(() => {
        window.location.reload();  // Tato metoda obnoví stránku
        getNewPaymentData()
      }, 1500);
    }
  };

  // Aktivace zrušeného předplatného
  const handleActivate = async () => {
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/payments/activate`, 
        { businessId: business._id },
        {
          headers: {
            Authorization: `Bearer ${businessToken}`
          },
        },
      );
      setMessage(response.data.message)
    } catch (err) {
      setMessage(err.response?.data?.message);
    } finally {
      setTimeout(() => {
        window.location.reload()
        getNewPaymentData()
      }, 1000)
    }
  };



    // Pokud není uživatel přihlášený
    if (!business || !businessToken) {
      return <BusinessLogin />
  }


  return (
    <div className="min-height">
    <Navbar />
    <div className="payment-form-container">
    <h2>Správa předplatného</h2>

    {business.subscriptionStatus === "active" &&
      <div className="subscription-status">
        <p>Předplatné aktivní</p>
      </div>}

      {business.subscriptionStatus === "pending" && <div className="payment-form-container-payment-form">
        <div className="subscription-options">
        <select value={plan} onChange={(e) => setPlan(e.target.value)} className="plan-select">
          <option value="">Vyberte plán</option>
          <option value="monthly">Měsíčně - {process.env.REACT_APP_MONTHLY_PRICE} Kč</option>
          <option value="yearly">Ročně - {process.env.REACT_APP_YEARLY_PRICE} Kč</option>
        </select>
        </div>
        <form onSubmit={handleSubmit} className="payment-form">
        <CardElement
                options={{
                  hidePostalCode: true,
                  style: {
                    base: {
                      fontSize: '16px',
                      color: '#424770',
                      '::placeholder': {
                        color: '#aab7c4',
                      },
                    },
                    complete: {
                      color: '#424770',
                    },
                    invalid: {
                      color: '#9e2146',
                    },
                  },
                }}
              />
          <button type="submit" className="submit-button">Zaplatit</button>
        </form>
      </div>}
      {business.subscriptionStatus === "cancelled" && <div className="subscription-status-cancelled">
        <p>Předplatné zrušeno</p>
      </div>}

    
    <div className="payment-history">
      {paymentData.map((item) => {
        console.log(item)
        return (
          <div>{item.status === "cancelled" && <div key={item._id} className="payment-item">

            {item.isCancellationRequested ? 
              <div>
                <h3 className="status-cancelled">Zrušeno, platí do konce zaplaceného období</h3>
                <button onClick={handleActivate} className="button activate">Obnovit</button> 
              </div>
              : 
              <button onClick={handleCancel} className="button cancel">Zrušit předplatné</button>}
          </div>}</div>
        );
      })}
    </div>
    {message && <p className="message">{message}</p>}  {/* Zobrazíme zprávu pro uživatele */}
    {loading && <div className="loading-spinner"></div>}  {/* Zobrazíme zprávu pro uživatele */}
  </div>
</div>
);
};

const App = () => (
  <Elements stripe={stripePromise} options={{ appearance }}>
    <PaymentForm />
  </Elements>
);

export default App;